// reducers/salaryReducer.js
export const salaryReducer = (state = { salaries: [] }, action) => {
  switch (action.type) {
    case "SALARY_REQUEST":
      return { ...state, loading: true, error: null, success: false };

    case "GET_SALARIES_SUCCESS":
      return { loading: false, salaries: action.payload };

    case "PROCESS_SALARY_SUCCESS":
      return { loading: false, success: true };

    case "PAY_SALARY_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        salaries: state.salaries.map((s) =>
          s.id === action.payload.id ? { ...s, ...action.payload } : s,
        ),
      };

    case "UPDATE_SALARY_STATUS_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        salaries: state.salaries.map((s) =>
          s.id === action.payload.id ? { ...s, ...action.payload } : s,
        ),
      };

    case "SALARY_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "CLEAR_ERRORS":
      return { ...state, error: null, success: false };

    default:
      return state;
  }
};
